import NetteAjax from './NetteAjax'
import getAssetName from '../../utils/getAssetName'

export function registerExtension(name, extension, context) {
  if (typeof extension === 'function') {
    extension = extension.call(null, NetteAjax, context)
    if (typeof extension.install === 'function') {
      context.vueApp.use(extension, context)
    }
    console.log('loaded ext', name)
    return { name, extension }
  }
}

function registerExtensions(extensions, requireContext, context) {
  const nameToFile = {}

  requireContext.keys().forEach((file) => {
    const name = getAssetName(file)
    if (extensions.indexOf(name) !== -1) {
      nameToFile[name] = file
    }
  })

  return extensions.map((name) => {
    if (Object.prototype.hasOwnProperty.call(nameToFile, name)) {
      let extension = requireContext(nameToFile[name])
      // Unwrap "default" from ES6 module
      if (Object.prototype.hasOwnProperty.call(extension, 'default')) extension = extension.default

      return registerExtension(name, extension, context)
    }
  })
}

export function loadExtensions(extensions, context) {
  const requireContext = require.context(
    // root folder for components
    './Ext/',
    // recursive
    true,
    // include all .js wo index.js
    /\/(?!index\.js$)(?:[^.]+)\.js$/
  )

  return registerExtensions(extensions, requireContext, context)
}

export default NetteAjax
